export default __webpack_public_path__ + "static/Asset5@2x-82b7093f8e603cd795cd25310ec2edfc.png";